// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const HorizontalRuleOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"currentColor","viewBox":"0 0 16 16","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M0 10.5a.5.5 0 01.5-.5h15a.5.5 0 010 1H.5a.5.5 0 01-.5-.5zM12 0H4a2 2 0 00-2 2v7h1V2a1 1 0 011-1h8a1 1 0 011 1v7h1V2a2 2 0 00-2-2zm2 12h-1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2H2v2a2 2 0 002 2h8a2 2 0 002-2v-2z"}}]},"name":"horizontal-rule","theme":"outlined"};

const HorizontalRuleOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={HorizontalRuleOutlinedSvg} />;
  HorizontalRuleOutlined.displayName = 'HorizontalRuleOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(HorizontalRuleOutlined);
